import { ITutorEducationDetails } from '@wot/typings';
import { useAppDispatch, useAppSelector } from '../../../hooks/useRedux';
import { updateProfile } from '../../../reducers/profileSlice';
import EducationDetails from '../../ProfileSetup/containers/Education/EducationDetails';
import { toast } from 'react-toastify';

export default function Education() {
  const dispatch = useAppDispatch();
  const { profile } = useAppSelector((state) => state.profileSlice);

  const onSaveEducation = async (data: ITutorEducationDetails) => {
    dispatch(updateProfile({ education: data, status: 'under-review' })).then(() => {
      toast.success('Education Details updated');
    });
  };

  return (
    <div className="relative h-[90%] max-w-5xl">
      <EducationDetails onSave={onSaveEducation} education={profile?.education} />
    </div>
  );
}
